import React from 'react';
import Button from 'react-bootstrap/Button';
import { useHistory } from 'react-router-dom';
import './TermsOfUse.scss';

const TermsOfUse = ({
	onBackClick,
}) => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const history = useHistory();

  //-------------------------------FUNCTIONS---------------------------------------------------------
  const onClick = () => {
    //history.push(Paths.user.signup);
    history.goBack();
  };

  //-------------------------------RETURN------------------------------------------------------------
  return (
		<div className="termsofuse_screen">
			<div className="termsofuse_content">
				<h3 className="termsofuse_ttl">
					【エアーインカムライト ご利用規約】
				</h3>
				<div className="termsofuse_list">
					<dl className="list">{/* 1 */}
						<dt>第１条 目的</dt>
						<dd>
							<p style={{paddingLeft:'1em',}}>
								本規約は、アルインコ株式会社（以下「当社」といいます）が提供する有償トランシーバーアプリケーションサービス「エアーインカムライト」（以下「本サービス」といいます）の利用に関し、必要な条件を定めることを目的とします。また、本サービスの利用に関し、当社が利用者に対してあらゆる媒体で告知する諸注意等は、本規約の一部を構成するものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 2 */}
						<dt>第２条 本規約の変更</dt>
							<dd>
								<p className="num">
									１．当社は、本サービスをご利用になるお客様（以下「利用者」といいます）の承諾を得ることなく本規約の内容を変更することがあります。この場合の利用条件は、変更後の本規約の規定によります。
								</p>
								<p className="num">
									２．当社が本規約の内容を変更した場合は、郵便又は当社ウェブサイトへの掲載等の合理的な方法をもって、変更内容を速やかに利用者に通知します。
								</p>
								<p className="num">
									３．本規約の変更後も利用者が本サービスの利用を継続した場合、利用者は、変更後の本規約に同意したものとみなします。利用者が変更後の本規約に同意しない場合は、本サービスの提供は終了するものとします。
								</p>
							</dd>
					</dl>
					<dl className="list">{/* 3 */}
						<dt>第３条 利用契約の締結</dt>
							<dd>
								<p className="num">
									１．利用者が本サービスの利用を希望する際は、本規約の内容を承諾の上、当社所定の方法により、本サービスの利用の申込みをすることとします。
								</p>
								<p className="num">
									２．当社が、前項に定める申込みを承諾したときに、利用者と当社との間で本サービスの利用契約（以下「本契約」といいます）が成立するものとします。なお、当社は、利用者に対し、当社所定の方法により申込みの諾否を速やかに通知します。
								</p>
								<p className="num">
									３．次のいずれかに該当する場合は、当社は第１項の申込みを承諾しないことがあります。
								</p>
								<ol>
									<li>
										<span className="ol_num">①</span>
										第１項に基づき申し込まれた内容に、虚偽若しくは不実の内容又は重大な記入漏れがあるとき。
									</li>
									<li>
										<span className="ol_num">②</span>
										利用者が利用料金の支払方法に指定した支払元金融機関口座が利用不能であるとき。
									</li>
									<li>
										<span className="ol_num">③</span>
										利用者が第 12 条第 1 項各号に該当するとき。
									</li>
									<li>
										<span className="ol_num">④</span>
										過去に本規約の規定により契約の解除を受けたことがあるとき。
									</li>
									<li>
										<span className="ol_num">⑤</span>
										その他当社の業務遂行や本サービスの提供に支障があるとき。
									</li>
								</ol>
								<p className="num">
									４．利用者は、本サービスの利用にあたり、自己の責任と費用においてスマートフォン端末を用意するものとします。また、本サービスを利用するためのアプリケーション「Air-InCom.Lite」（以下「本アプリ」といいます）を利用する端末は、本サービスを提供するための当社システムと接続が可能なネットワークに接続されている必要があり、その仕様等については、別途当社の定めるところによるものとします。
								</p>
							</dd>
					</dl>
					<dl className="list">{/* 4 */}
						<dt>第４条 ＩＤ等の付与</dt>
						<dd>
							<p className="num">
								１．当社は利用者に対し、利用者が本サービスを利用するためのＩＤ及びパスワード（以下、併せて「ＩＤ等」といいます）を付与するものとします。
							</p>
							<p className="num">
								２．利用者は、有償、無償を問わずＩＤ等を利用者以外の第三者へ譲渡又は貸与を行ってはならないものとします。
							</p>
							<p className="num">
								３．利用者は、ＩＤ等を善良な管理者の注意をもって管理し、第三者によるこれらの不正使用が想定される事態が発生したときは、速やかに当社に通知するものとします。当社は、ＩＤ等の使用上の過誤又は第三者による不正使用等について、一切の責任を負わないものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 5 */}
						<dt>第５条 本サービスの内容</dt>
						<dd>
							<p className="num">
								１．本アプリを利用しての通信は、本契約の成立時に利用者が作成したＩＤを用いての本アプリ間でのみご利用できます。
							</p>
							<p className="num">
								２．本サービスは、日本国外ではご利用できません。利用者が、日本国外で本サービスを利用した場合、当社は、本アプリの動作その他について、一切の責任を負わないものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 6 */}
						<dt>第６条 利用料金</dt>
						<dd>
							<p className="num">
								１．利用者は、当社が別に定める本サービスの利用料金等の契約内容に基づく費用（以下、これらを併せて「利用料金」といいます）を当社に対して支払うこととします。
							</p>
							{/* <p className="num">
								２．利用者は、当月分の利用料金（月末締め）を、翌月 20 日（金融機関の休業日の場合は翌営業日）に、利用者が指定した支払元金融機関口座からの振替によって支払うこととします。
							</p> */}
							<p className="num">
								２．利用者は、次に定めるいずれかの方法によって料金を支払うこととします。
							</p>
								<ol>
									<li>
										<span className="ol_num">①</span>
										月間でのご契約の場合<br/>
										当月分の利用料金（月末締め）を、翌月20日（金融機関の休業日の場合は翌営業日）に、利用者が指定した支払元金融機関口座からの振替払い。
									</li>
								</ol>
								<ol>
									<li>
										<span className="ol_num">②</span>
										年間でのご契約の場合<br/>
										年額の利用料金をご利用開始月の翌月20日（金融機関の休業日の場合は翌営業日）に、利用者が指定した支払元金融機関口座からの振替払い。
									</li>
								</ol>
								<ol>
									<li>
										<span className="ol_num">③</span>
										定量制（時間制）でのご契約の場合<br/>
										利用者が指定したクレジットカード払い、または現金お振込み。
									</li>
								</ol>
							<p className="num">
								３．前項の口座振替払いまたはクレジットカード払いについて、利用者は、金融機関の預金口座振替依頼書の提出その他必要な手続きを行うものとします。
							</p>
							<p className="num">
								４．利用料金の口座振替払いまたはクレジットカード払いの手続きには、申込みから金融機関またはクレジットカード会社の手続き完了までに最長60日程度かかることがあります。初回の支払日までに金融機関の手続きが完了しなかったときは、
							</p>
								<ol>
									<li>
										<span className="ol_num">①</span>
										月間でのご契約の場合、初回に支払うべき利用料金は翌月の支払日に翌月に支払うべき利用料金と合算してお支払いいただくこととし、
									</li>
								</ol>
								<ol>
									<li>
										<span className="ol_num">②</span>
										年間でのご契約の場合、ご利用開始月の翌月20日（金融機関の休業日の場合は翌営業日）にお支払いいただくこととします。クレジットカード払いの場合はご契約のクレジットカード会社のスケジュールでの振替となります。
									</li>
								</ol>
								<ol>
									<li>
										<span className="ol_num">③</span>
										定量制（時間制）でのご契約の場合、ご利用開始時にご契約頂いたレジットカード会社のスケジュールでの振替となります。
									</li>
								</ol>
							<p className="num">
								５．前項に関わらず、利用者が利用料金の支払いを遅滞した場合は、当社は本サービスの提供を停止することがあります。利用者による利用料金の滞納が支払期限より30日を超えた場合は、利用料金のほか、支払期限の翌日から年14.6％の遅延利息を当社に支払うこととします。
							</p>
							<p className="num">
								６．本契約の解約は次のとおりとします。この場合、解約時典において未払いの利用料金及び遅延利息があるときは直ちにこれを支払うこととします。ただし、当社の責めに帰すべき事由により解約する場合は、本項の限りでありません。
							</p>
								<ol>
									<li>
										<span className="ol_num">①</span>
										月間でのご契約の場合<br/>
										当月15日までに、解約の申告及び当社の受付が完了した場合、当月末日切でのご解約扱いとなります。当月16日以降に解約の申告及び当社の受付が完了した場合、翌月末切でのご解約扱いとなります。
									</li>
								</ol>
								<ol>
									<li>
										<span className="ol_num">②</span>
										年間でのご契約の場合<br/>
										契約期間の途中で解約できません。
									</li>
								</ol>
								<ol>
									<li>
										<span className="ol_num">③</span>
										定量制（時間制）でのご契約の場合<br/>
										ご契約いただいた時間のすべてをご利用いただいた場合、もしくはご契約いただいた時間が残存する場合であって当該時間に関するご契約の日から1年を経過した場合（ご契約の日から1年を経過するまでの間に新たな定量制のご契約をいただいた場合、残存する時間及び新たなご契約に基づく時間のいずれについても、当該新たなご契約の日から1年を経過した場合も同様とする）、同時点をもってご解約扱いとなります。
									</li>
								</ol>
							<p className="num">
								７．当社は、利用者の承諾なく利用料金の改定を行うことがあります。この場合、減額の場合を除き、改定を行う日の1か月前までに、郵便又は当社ウェブサイトへの掲載等の合理的な方法をもって、利用者にその旨を通知します。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 7 */}
						<dt>第７条 変更の届出</dt>
						<dd>
							<p className="num">
								１．利用者は、氏名、名称、住所等の連絡先又は支払方法に変更があるときは、速やかに当社に届け出るものとします。
							</p>
							<p className="num">
								２．当社が、前項の事実を証明する書類の提出を求めた場合は、利用者は、これに応じるものとします。
							</p>
							<p className="num">
								３．利用者が第１項の届出を怠り又は届出の内容を誤ったことに起因して利用者に発生する不利益については、当社は責任を負わないものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 8 */}
						<dt>第８条 権利義務の譲渡等の禁止</dt>
						<dd>
							<p className="num">
								１．利用者は、当社の書面による事前の承諾がない限り、本サービスに関する権利及び義務の全部又は一部を、第三者へ譲渡、承継、担保設定、貸与、その他一切の処分（以下「譲渡等」といいます）をすることができないものとします。
							</p>
							<p className="num">
								２．利用者が前項の承認を受けようとするときは、当社所定の方法により、販売店で請求を行うこととします。
							</p>
							<p className="num">
								３．前項の請求について、次のいずれかに該当する場合は、当社は前項の請求を承認しないことがあります。
							</p>
							<ol>
								<li>
									<span className="ol_num">①</span>
									請求された内容に、虚偽若しくは不実の内容又は重大な記入漏れがあるとき。
								</li>
								<li>
									<span className="ol_num">②</span>
									譲受人が本契約に基づく利用料金の支払いを怠るおそれがあるとき。
								</li>
								<li>
									<span className="ol_num">③</span>
									譲受人が第 12 条第 1 項各号に該当するとき。
								</li>
								<li>
									<span className="ol_num">④</span>
									譲受人が過去に本規約の規定により契約の解除を受けたことがあるとき。
								</li>
								<li>
									<span className="ol_num">⑤</span>
									その他、当社の業務遂行や本サービスの提供に支障があるとき。
								</li>
							</ol>
							<p className="num">
								４．当社が第２項の請求を承認したときは、譲受人は、譲渡人である利用者が本契約に基づいて有する一切の権利と義務を承継するものとします。
							</p>
							<p className="num">
								５．利用者が第１項の書面による承諾を得ないで、本サービスに関する権利若しくは義務を第三者に譲渡等したときには、本契約は終了するものとします。この場合、利用者は、未払利用料金の支払及び当社への損害賠償義務を免れないものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 9 */}
						<dt>第９条 禁止事項</dt>
						<dd>
							<p className="num">
								１．利用者は、本サービスを利用するにあたり、以下のいずれかに該当する行為及び該当するおそれのある行為をしてはならないものとします。
							</p>
							<ol style={{margin:'0'}}>
								<li>
									<span className="ol_num">①</span>
									本規約に違反する行為。
								</li>
								<li>
									<span className="ol_num">②</span>
									法令に違反する行為、犯罪行為又はそれに結びつく行為。
								</li>
								<li>
									<span className="ol_num">③</span>
									公序良俗に反する行為。
								</li>
								<li>
									<span className="ol_num">④</span>
									当社又は第三者の知的財産権、名誉権、プライバシー権、その他の権利又は利益を侵害する行為
								</li>
								<li>
									<span className="ol_num">⑤</span>
									当社のネットワーク又はシステム等に不正にアクセスし、又は不正なアクセスを試みる行為
								</li>
							</ol>
							<ol style={{margin:'0'}}>
								<li>
									<span className="ol_num">⑥</span>
									本サービスのシステム設備、電気通信設備等の運営に支障を与える行為
								</li>
								<li>
									<span className="ol_num">⑦</span>
									通信の伝送交換に妨害を与える行為又は通信のふくそうを生じさせる行為
								</li>
								<li>
									<span className="ol_num">⑧</span>
									本サービスに有害なコンピュータプログラム等を含む内容を送信又は投稿する行為
								</li>
								<li>
									<span className="ol_num">⑨</span>
									本サービスの運営を妨害する恐れのある行為
								</li>
								<li>
									<span className="ol_num">⑩</span>
									当社の同意なく、本サービス上で本アプリ以外のアプリケーションを利用する行為
								</li>
							</ol>
							<ol style={{margin:'0'}}>
								<li>
									<span className="ol_num">⑪</span>
									本サービス上で通信された内容等を発信者の同意なく外部に転載する行為
								</li>
								<li>
									<span className="ol_num">⑫</span>
									第三者になりすまして本サービスを利用する行為
								</li>
								<li>
									<span className="ol_num">⑬</span>
									本サービスの他の利用者のＩＤ等を利用する行為
								</li>
								<li>
									<span className="ol_num">⑭</span>
									第三者に無断で情報又はデータを取得、収集、集積又は送信する行為
								</li>
								<li>
									<span className="ol_num">⑮</span>
									当社又は第三者に不利益、不快感等の損害を与える行為
								</li>
							</ol>
							<ol style={{margin:'0'}}>
								<li>
									<span className="ol_num">⑯</span>
									本サービス上に個人を特定できる情報を登録する行為
								</li>
								<li>
									<span className="ol_num">⑰</span>
									面識のない異性との出会いを目的とした行為
								</li>
								<li>
									<span className="ol_num">⑱</span>
									第三者を差別若しくは誹謗中傷し、又はその名誉若しくは信用を毀損する行為
								</li>
								<li>
									<span className="ol_num">⑲</span>
									わいせつ、児童虐待若しくは児童ポルノなど児童及び青少年に悪影響を及ぼす音声を送信する行為
								</li>
								<li>
									<span className="ol_num">⑳</span>
									前各号のいずれかに該当する行為を援助又は助長する行為
								</li>
							</ol>
							<ol style={{margin:'0'}}>
								<li>
									<span className="ol_num">㉑</span>
									その他、当社が不適切と判断した行為
								</li>
							</ol>
							<p className="num">
								２．利用者が前項の禁止事項に該当する行為を行った場合、当社は、当該利用者に予告することなく直ちに、利用者情報の抹消、本サービス利用の一時的又は永久的な停止など、当社が必要と判断する処置を取ることができるものとし、当該処置により、当該利用者に不利益や損害が生じた場合でも、当社はその責任を負わないものとします。
							</p>
							<p className="num">
								３．利用者が第１項の禁止事項に該当する行為を行ったことにより当社又は第三者が損害を被った場合、利用者はその損害（弁護士費用を含む）を賠償するものとします。また、当社は、利用者の当該行為により第三者に生じた不利益や損害について、責任を負わないものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 10 */}
						<dt>第 10 条 損害賠償</dt>
						<dd>
							<p className="num">
								利用者は、本サービスの利用を通じて当社又は第三者に損害を与えた場合、その損害（弁護士費用を含む）を賠償するものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 11 */}
						<dt>第 11 条 本契約の解約</dt>
						<dd>
							<p className="num">
								１．利用者は、当社所定の方法により、本契約の全部又は一部を解約することができるものとします。
							</p>
							<p className="num">
								２．当社は、利用者が次の各号の一に該当する場合は、何らの催告をすることなく、ただちに本契約の全部又は一部を解除することができるものとします。
							</p>
							<ol style={{margin:'0'}}>
								<li>
									<span className="ol_num">①</span>
									利用者が、本サービスその他当社が提供する一切の通信サービスについて不正な使用をしているか、その恐れがあるとき。
								</li>
								<li>
									<span className="ol_num">②</span>
									第３条第１項の申込みにあたり、当社に虚偽若しくは不実の内容を告知したことが判明したとき。
								</li>
								<li>
									<span className="ol_num">③</span>
									利用者が、利用料金の支払いを滞納したとき、その他利用者が本規約に定める利用者の義務に違反したとき。
								</li>
								<li>
									<span className="ol_num">④</span>
									利用者が、支払停止若しくは支払不能の状態に陥ったとき、又は手形若しくは小切手が不渡りとなったとき。
								</li>
								<li>
									<span className="ol_num">⑤</span>
									利用者が、第三者より差押え、仮差押え、仮処分若しくは競売の申立て、又は公租公課の滞納処分を受けたとき。
								</li>
							</ol>
							<ol style={{margin:'0'}}>
								<li>
									<span className="ol_num">⑥</span>
									利用者が、破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始の申立てを受け、又は自ら申立てを行ったとき。
								</li>
								<li>
									<span className="ol_num">⑦</span>
									利用者が、解散、会社分割、事業譲渡又は合併の決議をしたとき。
								</li>
								<li>
									<span className="ol_num">⑧</span>
									利用者の資産又は信用状態に重大な変化が生じ、本規約に基づく債務の履行が困難になるおそれがあると認められるとき。
								</li>
								<li>
									<span className="ol_num">⑨</span>
									その他、前各号に準じる事由が生じたとき。
								</li>
							</ol>
						</dd>
					</dl>
					<dl className="list">{/* 12 */}
						<dt>第 12 条 反社会的勢力の排除</dt>
						<dd>
							<p className="num">
								１．当社は、利用者が次の各号の一に該当する場合は、何らの催告をすることなく、ただちに本契約契約の全部又は一部を解除することができるものとします。
							</p>
							<ol>
								<li>
									<span className="ol_num">①</span>
									利用者が、暴力団、暴力団関係企業、総会屋等の反社会的勢力（以下「反社会的勢力」という）の構成員である場合
								</li>
								<li>
									<span className="ol_num">②</span>
									利用者が、反社会的勢力又はそれらの構成員と社会的に非難されるべき関係を有する場合
								</li>
								<li>
									<span className="ol_num">③</span>
									利用者が、当社に対して暴力行為、脅迫行為を行う場合
								</li>
								<li>
									<span className="ol_num">④</span>
									利用者が、偽計又は威力を用いて当社の業務を妨害する場合
								</li>
								<li>
									<span className="ol_num">⑤</span>
									その他、利用者が前各号に準ずる行為を行う場合
								</li>
								<li>
									<span className="ol_num">⑥ </span>
									利用者の役員若しくは実質的に経営を支配する者が、前各号のいずれかに該当する場合、又は該当する行為を行う場合
								</li>
							</ol>
							<p className="num">
								２．前項による解除は、当社が被った損害につき利用者に対し損害賠償請求をすることを妨げないものとします。また、当該解除により利用者に損害が生じた場合でも、当社は責任を負わないものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 13 */}
						<dt>第 13 条 本サービス提供の停止</dt>
						<dd>
							<p style={{paddingLeft:'1em',}}>
								第 11 条条第２項各号の一つでも該当したときは、その状態が解消されるまでの間、当社は利用者に対する本サービスの提供を停止できるものとします。この場合でも、その期間に発生する利用料金は利用者の負担とします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 14 */}
						<dt>第 14 条 本サービス提供の中止</dt>
						<dd>
							<p className="num">
								１．当社は、次の場合は、予告なく本サービスの提供を中止することがあります。
							</p>
							<ol>
								<li>
									<span className="ol_num">①</span>
									天災、事変その他当社の責に帰さない事由により本サービスの提供ができないとき。
								</li>
								<li>
									<span className="ol_num">②</span>
									当社の設備の保守、工事又は故障など合理的な事由によりやむをえず本サービスの提供ができないとき。
								</li>
								<li>
									<span className="ol_num">③</span>
									その他、当社が本サービスの全部又は一部の提供の停止が必要と判断した場合。
								</li>
							</ol>
							<p className="num">
								２．本サービスが中止されたことに起因する利用者の損害は、原因、内容及び程度にかかわらず、当社は一切の責任を負わないものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 15 */}
						<dt>第 15 条 本サービスの廃止</dt>
						<dd>
							<p className="num">
								１．当社の経営の変化や設備の老朽化、通信技術の革新による本サービスの陳腐化、その他の合理的でやむを得ないと判断される事由が発生したときは、当社は本サービスの提供を廃止します。この場合、当社は、郵便又は当社ウェブサイトへの掲載等の合理的な方法をもって、利用者にその旨を通知します。
							</p>
							<p className="num">
								２．前項の規定により本サービスを廃止した場合の利用料金は、本契約の定めにより清算します。
							</p>
							<p className="num">
								３．本サービスが廃止されたことに起因する利用者の損害は、原因、内容及び程度にかかわらず、当社は一切の責任を負わないものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 16 */}
						<dt>第 16 条 知的財産権の取扱い</dt>
						<dd>
							<p className="num">
								１．本サービスの提供に関し、当社が利用者に提供する情報（画像・映像・文章・プログラムその他編集されたすべての内容）に関する著作権、特許権、実用新案権、意匠権、商標権、ノウハウ等の知的財産権（著作権については、著作権法第 27 条及び 第 28 条の権利を含む）は、当社及び当社が使用許諾を受けている第三者に帰属します。
							</p>
							<p className="num">
								２．本規約に基づく本サービス及び本アプリの利用許諾は、利用者に対してなんらの権利移転を意味するものではありません。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 17 */}
						<dt>第 17 条 利用者情報等の取扱い</dt>
						<dd>
							<p className="num">
								１．当社は、本サービスの提供にあたり利用者より取得した個人情報について、当社の定めるプライバシーポリシーに従い、契約の申込みと締結、利用料金の適用や請求等、当社が本契約に係る業務の遂行に必要な範囲で使用できるものとします。
							</p>
							<p className="num">
								２．当社は、前項の個人情報を、当社が業務委託する第三者にその業務の遂行に必要な範囲で提供できるものとします。この場合、当社は、当社の定めるプライバシーポリシーに従い、業務委託先の第三者を厳正に管理するものとします。
							</p>
							<p className="num">
								３．利用者は、当社が、利用者情報を利用者が特定できない統計的な情報として利用し、公開する場合があることに同意するものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 18 */}
						<dt>第 18 条 免責事項</dt>
						<dd>
							<p className="num">
								１．当社は、次に定める事由により利用者に発生した損害について、一切の責任を負わないものとします。
							</p>
							<ol>
								<li>
									<span className="ol_num">①</span>
									第三者による本サービスに対する妨害行為。
								</li>
								<li>
									<span className="ol_num">②</span>
									第三者による本アプリの改変、当社システムへの不正アクセス、コンピュータウィルスの混入等の不正行為。
								</li>
								<li>
									<span className="ol_num">③</span>
									GPSなどの装置の位置情報データに発生した誤差やエラー等の障害。
								</li>
								<li>
									<span className="ol_num">④</span>
									各通信キャリア会社の都合による本サービスの障害。
								</li>
								<li>
									<span className="ol_num">⑤</span>
									利用者の故意又は過失による誤用、その他当社が製品の説明書類で禁止している使用方法により発生した障害。
								</li>
								<li>
									<span className="ol_num">⑥</span>
									第 11 条第 2 項各号に定める事由。
								</li>
							</ol>
							<p className="num">
								２．当社は、本サービス上の全ての情報に関する網羅性、完全性、正確性、可用性、永続性、信頼性、安全性、合法性、最新性等について一切の保証を行わないものとします。本サービス上で使用される全ての情報の利用は利用者の自己責任のもとで行われるものとします。
							</p>
							<p className="num">
								３．当社は、本サービスが利用者の特定の目的に適合すること、期待する機能、商品価値、有用性を有すること、バグやエラー、セキュリティーなどに関する不具合が生じないこと、いかなる環境においても中断せずに利用可能なことについて一切の保証を行わないものとします。継続的に本サービスが提供されないことにより利用者に不利益や損害が生じた場合でも、当社はその責任を負わないものとします。
							</p>
							<p className="num">
								４．当社は、本サービス上で通信される内容等に、コンピュータウィルス等の有害なものが含まれないことを保証せず、通信の内容については一切の保証を行わないものとします。利用者が本サービスを利用する過程で何らかの不利益や損害を被ったとしても、当社はその責任を負わないものとします。
							</p>
							<p className="num">
								５．当社は、本アプリのバグその他の不具合を補修する義務、及び本アプリを改良又は改善する義務を負わないものとします。ただし、利用者に本アプリのアップデート版又はバージョンアップ情報等を提供する場合があります。この場合、かかるアップデート版又はバージョンアップ情報等も本アプリとして扱い、これらに対しても本規約が自動的に適用されます。
							</p>
							<p className="num">
								６．本サービスの利用に関し、利用者間での紛争、トラブル等が生じたとしても、当社は一切関知せず、利用者間で解決するものとします。
							</p>
							<p className="num">
								７．当社は、本サービスに関して、別段の合意がない限り、いかなる理由があっても利用者に対して返金の義務を負わないものとします。
							</p>
							<p className="num">
								８．当社は、利用者又は第三者に対して何らかの損害賠償責任を負う場合、その責任の範囲は、利用者又は第三者に現実に生じた通常の範囲の損害に限るものとし、特別な事情から生じた損害については、その予見又は予見可能性の有無にかかわらず、責任を負わないものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 19 */}
						<dt>第 19 条 第三者への委託</dt>
						<dd>
							<p style={{paddingLeft:'1em',}}>
								当社は、本規約に定める当社の業務の全部又は一部を第三者に委託できるものとします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 20 */}
						<dt>第 20 条 輸出管理</dt>
						<dd>
							<p style={{paddingLeft:'1em',}}>
								利用者は、本サービスを利用する一切の機械装置、本アプリを含むコンピューター･プログラム等（役務提供及び関連技術情報を含む）を輸出しないことに同意します。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 21 */}
						<dt>第 21 条 合意管轄</dt>
						<dd>
							<p style={{paddingLeft:'1em',}}>
								本規約及び本サービスに関する一切の紛争は、大阪地方裁判所を第一審の専属的合意管轄裁判所とします。
							</p>
						</dd>
					</dl>
					<dl className="list">{/* 附則 */}
						<dt>附則</dt>
						<dd>
							<p style={{paddingLeft:'1em',}}>
								本規約は2024年3月21日から実施します。
							</p>
						</dd>
					</dl>
				</div>
				{((!!history && (history.length > 1)) || !!onBackClick) && (<div className="termsofuse_button">
					<Button
						className="button"
						onClick={!!onBackClick ? onBackClick:onClick}
					>
						戻る
					</Button>
				</div>)}
			</div>
		</div>
	);
};
export default TermsOfUse;
